import { createPartyRequest } from './helper';
export const getAvailabilityCheck = createPartyRequest({
    route: '/party/availabilitycheck',
    method: 'get',
    source: 'data',
});
